// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessAlert_root__L2p1z"};